module.exports = __webpack_public_path__ + "img/vedio.2b381b73.png";